import get from 'lodash/get'
import OLLayerTile from 'ol/layer/Tile'
import { transformExtent as OLProjTransformExtent } from 'ol/proj'
import OLSourceXYZ from 'ol/source/XYZ'

import type { Extent } from 'ol/extent'
import type { TileImage } from 'ol/source'
import type { Options as XyzTileOptions } from 'ol/source/XYZ'

import * as PoziUtils from 'api/utils'
import LoaderXYZ from 'config/LoaderXYZ'
import { MapLayer } from 'config/MapLayer'
import type { ConfigLayerTileWMSOptions } from 'config/MapLayerTileWMS'
import SetAttributions from 'config/SetAttributions'
import { setLayerLoadDone } from 'drawer/tabs/layers/actions'

export interface ConfigLayerXyzTileOptions extends XyzTileOptions {
  title: string
  titleid: string
  group: string
  source: any // FIXME: I am not sure about this?!
  opacity: any // FIXME: I am not sure about this?!
  visible: boolean // FIXME: I am not sure about this?!
  extent?: any // FIXME: I am not sure about this?!
  minResolution?: number // FIXME: I am not sure about this?!
}

export class MapLayerXyzTile extends MapLayer {
  static createLayer (layerConf: ConfigLayerTileWMSOptions): OLLayerTile<TileImage> {
    this.preLayer(layerConf)

    let olSourceXYZ
    const loaderType = get(layerConf, 'config.loader', '')
    if (loaderType !== '') {
      olSourceXYZ = LoaderXYZ(loaderType, layerConf.config)
    } else {
      olSourceXYZ = new OLSourceXYZ(layerConf.config)
    }

    let view: Extent
    if (layerConf.extent) {
      view = OLProjTransformExtent(layerConf.extent, 'EPSG:4326', 'EPSG:3857')
    } else {
      view = OLProjTransformExtent([-180, -90, 180, 90], 'EPSG:4326', 'EPSG:3857')
    }

    const xyzTileOptions: ConfigLayerXyzTileOptions = {
      title: layerConf.title,
      titleid: layerConf.titleid,
      group: layerConf.group,
      source: olSourceXYZ,
      extent: view,
      maxResolution: layerConf.maxResolution || 100000,
      minResolution: layerConf.minResolution || 0.0001,
      opacity: layerConf.opacity || 1,
      visible: PoziUtils.isLayerSelected(layerConf, true)
    }

    const olLayer = new OLLayerTile(xyzTileOptions)

    if (olSourceXYZ) {
      PoziUtils.setSourceLoaded(olLayer, olSourceXYZ, layerConf)

      // Hack to mark layer as loaded once 1 tile has successfully loaded
      olSourceXYZ.once('tileloadend', () => {
        window.store.dispatch(setLayerLoadDone(layerConf.titleid))
      })

      olSourceXYZ.on('tileloaderror', function (event) {
        // const errorMsg = 'Layer load failed ' + layerConf.title
        // PoziUtils.gtag({
        //   category: 'data',
        //   status: 'warning',
        //   identifier: layerConf.title,
        //   action: 'ajax request',
        //   additionalInfo: errorMsg
        // })
        console.error('XYZ layer tile load error for layer ' + layerConf.title, event)
      })
    } else {
      console.log('MapLayerXyzTile - createLayer - not able to create OL source!', layerConf.titleid, layerConf)
    }

    // Add attributions for Nearmap layers
    // TODO: do this in a better way
    const url = PoziUtils.getLayerUrl(layerConf) || ''

    if (olSourceXYZ && url.includes('nearmap.com')) {
      const attributions = [
        '<a target="_blank" rel="noopener noreferrer" href="https://nearmap.com">© Nearmap</a>'
      ]

      SetAttributions(olLayer, attributions, true)
    }

    return olLayer
  }
}
